import React from "react";
import ProfileStatsBlock from "../../../../components/profileStatsBlock/profileStatsBlock";
import { useSelector } from "react-redux";

const PoorPerformers = ({ index }) => {
  const poorPerformers = useSelector((state) => state.attendance.poorPerformers);

  return <ProfileStatsBlock data={poorPerformers} index={index} />;
};

export default PoorPerformers;
